import { useThemeUI } from 'theme-ui';

export function useModalZIndex(): number {
	const {
		theme: { zIndices },
	} = useThemeUI();
	return (zIndices as Record<string, number>).modal;
}
